import React from 'react'

const PlaylistPlaceholder = (props) => {
  const left = props.depth * 24
  return (
    <div className="bg-pink h-[2px] w-[150px] relative" style={{ left }}></div>
  )
}

export default PlaylistPlaceholder
